import { makeAutoObservable, runInAction } from 'mobx'
import { storeMobx, restaurantConfig } from '..'
import QueueAPI from 'api/queue.api'

class Queue {
  constructor () {
    makeAutoObservable(this)
  }

  /** 当前门店排队点餐配置 */
  queueConfig: IQueueConfig = {} as any

  /** 当前排队信息 */
  queueInfo: IQueueInfo = {} as any

  /** 初始化 */
  async init () {
    const params = {
      brandId: storeMobx.info.brandId || restaurantConfig.brandId,
      storeId: storeMobx.info.storeId || restaurantConfig.storeId,
    }
    const res = await QueueAPI.getCallConfig(params)
    runInAction(() => {
      if (!res?.error) {
        this.queueConfig = res
      }
    })
    return res
  }

  /** 取号 */
  async callNono (params: { person?: number; kids?: number; contactName?: string; contactMobile?: string; seatAreaId?: number; memberId?: string }) {
    const res = await QueueAPI.callNono({
      brandId: storeMobx.info.brandId || restaurantConfig.brandId,
      storeId: storeMobx.info.storeId || restaurantConfig.storeId,
      ...params
    })
    return res
  }

  /** 获取取号信息 */
  async getCallInfo (params?: { callId?: number; contactMobile?: string; seatAreaId?: number; memberId?: string }) {
    params = params || {}
    params.memberId = params.memberId || restaurantConfig.member?.id || undefined
    params.callId = params.callId || restaurantConfig.queueId || undefined
    if ((!params.memberId || ['-1', '0'].includes(params.memberId)) && !params.callId) {
      return false
    }
    const res = await (QueueAPI as any).getCallInfo({
      brandId: storeMobx.info.brandId || restaurantConfig.brandId,
      storeId: storeMobx.info.storeId || restaurantConfig.storeId,
      ...params
    }) || {}
    runInAction(() => {
      if (!res?.error) {
        this.queueInfo = res
      }
    })
    return res
  }

  /** 更新取号信息 */
  resetQueueInfo (data: IQueueInfo) {
    this.queueInfo = data
  }

  /** 用户自主入桌 */
  async checkinCallByBuyer (params?: { callId?: number; tableCode?: string; contactName?: string }) {
    params = params || {}
    params.callId = params.callId || this.queueInfo?.callId || restaurantConfig.queueId || undefined
    params.contactName = params.contactName || this.queueInfo?.contactName
    params.tableCode = params.tableCode || this.queueInfo?.tableCode || restaurantConfig.tableCode
    const res = await (QueueAPI as any).checkinCallByBuyer({
      brandId: storeMobx.info.brandId || restaurantConfig.brandId,
      storeId: storeMobx.info.storeId || restaurantConfig.storeId,
      ...params
    })
    return res
  }
}

export default new Queue()
